import { ProdPayMasterSheetList } from './views';

export default {
  list: ProdPayMasterSheetList,
  name: 'prod-pay-master-sheet',
  label: 'Prod Payables MS',
  to: '/prod-pay-master-sheet',
};
